/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_A1Inputs */

const en_simple_oto_faq_a1 = /** @type {(inputs: Simple_Oto_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. You only answer questions about your business and approve each stage. Nothing has to be installed on your computer.`)
};

const id_simple_oto_faq_a1 = /** @type {(inputs: Simple_Oto_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa. Kamu hanya menjawab pertanyaan tentang usahamu dan menyetujui tiap tahap. Tidak ada yang perlu dipasang di komputermu.`)
};

/**
* | output |
* | --- |
* | "Yes. You only answer questions about your business and approve each stage. Nothing has to be installed on your computer." |
*
* @param {Simple_Oto_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_a1 = /** @type {((inputs?: Simple_Oto_Faq_A1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_A1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_a1(inputs)
	return en_simple_oto_faq_a1(inputs)
});